import merge from 'lodash/merge';
import { DiscussionComment } from '../types/discussion-comment';
import { DiscussionCommentActions } from '../types/discussion-comment-actions';
import { DiscussionActions } from '../types/discussion-actions';

export function discussionComments(
    state: { [id: string]: DiscussionComment } = {},
    action: DiscussionActions | DiscussionCommentActions
) {
    switch (action.type) {
        case 'discussions/fetch-success':
            return { ...state, ...action.data.entities.comments };
        case 'discussions/loadmore-success':
            if (action.data.result.length > 0) {
                return {
                    ...state,
                    ...action.data.entities.comments
                };
            } else {
                return {
                    ...state
                };
            }
        case 'discussion-comments/create-success':
            return {
                ...state,
                [action.data.result]:
                    action.data.entities.comments[action.data.result]
            };

        case 'discussion-comments/update-success':
            const commentId = action.commentId;
            const comment = action.data.entities.comments[commentId];
            return {
                ...state,
                [commentId]: {
                    ...state[commentId],

                    description: comment.description
                }
            };

        case 'discussion-comments/fetch-success':
            return merge(state, action.data.entities.comments);
        
        default:
            return state;
    }
}
